module.exports = __webpack_public_path__ + "img/29passenger_stopped.16811ed9.svg";